import {makeStyles} from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    height: "calc(100% - 30px)"
  },
  controls: {
    display: "flex",
    marginBottom: "16px",
    alignItems: "flex-end",
  },
  title: {
    ...theme.typography.body2,
    color: theme.palette.common.black,
    marginBottom: "4px",
  },
  time: {
    marginLeft: 16,
  },
  timeInput: {
    height: 40,
    border: "1px solid #bdbdbd",
    borderRadius: 4,
  },
  tableContainer: {
    flex: 1,
  },
  tableRoot: {}
}));